import * as React from "react";

export interface Props {
    onClick: () => void;
    className?: string;
}

export const CloseXIcon = (props: Props) => {
    const style = props.onClick ? {cursor: 'pointer'} : null;

    return (
        <svg style={style} onClick={props.onClick} version="1.1" className={props.className} x="0px" y="0px" width="26px" height="26px" viewBox="0 0 26 26" >
            <rect x="12.462" y="-1.876" transform="matrix(0.7067 -0.7076 0.7076 0.7067 -5.3818 13.0187)" fill="#333333" width="1.096" height="29.751"/>
            <rect x="12.462" y="-1.876" transform="matrix(0.7073 0.7069 -0.7069 0.7073 12.9972 -5.3924)" fill="#333333" width="1.097" height="29.752"/>
        </svg>
    );
};
